import { useState } from "react";

// Icon Components
const ChevronDown = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6 9L12 15L18 9" stroke="#917c66" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const PhoneIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M22 16.92V19.92C22.0011 20.1985 21.9441 20.4742 21.8325 20.7292C21.7209 20.9841 21.5573 21.2126 21.3522 21.3992C21.1472 21.5858 20.9051 21.7262 20.6421 21.811C20.3791 21.8958 20.101 21.9231 19.8267 21.8907C16.7427 21.5856 13.787 20.5341 11.19 18.8207C8.77382 17.3376 6.72533 15.2891 5.24233 12.8727C3.51159 10.2429 2.45783 7.24699 2.16 4.14C2.12768 3.86589 2.15506 3.58789 2.2399 3.32497C2.32474 3.06205 2.46508 2.82008 2.65164 2.61516C2.8382 2.41024 3.06664 2.24677 3.32154 2.13527C3.57644 2.02377 3.85207 1.96689 4.13 1.968H7.13C7.59757 1.96811 8.04592 2.14936 8.37796 2.47139C8.71 2.79342 8.90119 3.23189 8.91 3.7C9.00474 4.86331 9.21192 6.01374 9.527 7.13C9.68019 7.65611 9.64642 8.21913 9.43096 8.72611C9.2155 9.23309 8.83174 9.6545 8.34 9.92L6.75 11.51C8.22664 14.4025 10.5675 16.7434 13.46 18.22L15.05 16.63C15.3155 16.1383 15.7369 15.7545 16.2439 15.5391C16.7509 15.3236 17.3139 15.2898 17.84 15.443C18.9563 15.7581 20.1067 15.9653 21.27 16.06C21.7381 16.0688 22.1766 16.26 22.4986 16.592C22.8206 16.9241 23.0019 17.3724 23.002 17.84L22.999 16.92H22Z" fill="#917c66"/>
  </svg>
);

const MailIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4 4H20C21.1 4 22 4.9 22 6V18C22 19.1 21.1 20 20 20H4C2.9 20 2 19.1 2 18V6C2 4.9 2.9 4 4 4Z" stroke="#917c66" strokeWidth="2" fill="none"/>
    <path d="M22 6L12 13L2 6" stroke="#917c66" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
  </svg>
);

export default function ContactForm() {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    location: "",
    propertyType: "",
    bathrooms: "",
    bedrooms: "",
    budget: "",
    contactMethod: "phone",
    message: "",
    termsAccepted: false,
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log("Form submitted:", formData);
    // Handle form submission logic here
  };

  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>
  ) => {
    const { name, value, type } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]:
        type === "checkbox" ? (e.target as HTMLInputElement).checked : value,
    }));
  };

  return (
    <div className="w-full bg-white py-16 md:py-20 lg:py-24 px-6 md:px-12 lg:px-16 xl:px-20">
      <div className="max-w-6xl mx-auto flex flex-col gap-8 lg:gap-12">
        {/* Header Section */}
        <div className="flex flex-col gap-2">
          <div className="relative">
            <h1 className="text-2xl md:text-3xl lg:text-4xl font-semibold leading-[150%] text-primary">
              Let's Make it Happen
            </h1>
          </div>
          <p className="text-sm md:text-base font-normal leading-[150%] text-black">
            Ready to take the first step toward your dream property? Fill out
            the form below, and our real estate wizards will work their magic to
            find your perfect match.
          </p>
        </div>

        {/* Form Section */}
        <form
          onSubmit={handleSubmit}
          className="border border-gray-200 p-6 md:p-8 lg:p-10 bg-white"
        >
          <div className="space-y-6 lg:space-y-8">
            {/* First Row: First Name, Last Name, Email, Phone */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
              <FormField label="First Name">
                <input
                  type="text"
                  name="firstName"
                  value={formData.firstName}
                  onChange={handleInputChange}
                  placeholder="Enter First Name"
                  className="form-input"
                />
              </FormField>
              <FormField label="Last Name">
                <input
                  type="text"
                  name="lastName"
                  value={formData.lastName}
                  onChange={handleInputChange}
                  placeholder="Enter Last Name"
                  className="form-input"
                />
              </FormField>
              <FormField label="Email">
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  placeholder="Enter your Email"
                  className="form-input"
                />
              </FormField>
              <FormField label="Phone">
                <input
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={handleInputChange}
                  placeholder="Enter Phone Number"
                  className="form-input"
                />
              </FormField>
            </div>

            {/* Second Row: Location, Property Type, Bathrooms, Bedrooms */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
              <FormField label="Preferred Location">
                <div className="relative">
                  <select
                    name="location"
                    value={formData.location}
                    onChange={handleInputChange}
                    className="form-select"
                  >
                    <option value="">Select Location</option>
                    <option value="downtown">Downtown</option>
                    <option value="suburbs">Suburbs</option>
                    <option value="waterfront">Waterfront</option>
                  </select>
                  <div className="absolute right-4 top-1/2 -translate-y-1/2 pointer-events-none">
                    <ChevronDown />
                  </div>
                </div>
              </FormField>
              <FormField label="Property Type">
                <div className="relative">
                  <select
                    name="propertyType"
                    value={formData.propertyType}
                    onChange={handleInputChange}
                    className="form-select"
                  >
                    <option value="">Select Property Type</option>
                    <option value="house">House</option>
                    <option value="apartment">Apartment</option>
                    <option value="condo">Condo</option>
                    <option value="villa">Villa</option>
                  </select>
                  <div className="absolute right-4 top-1/2 -translate-y-1/2 pointer-events-none">
                    <ChevronDown />
                  </div>
                </div>
              </FormField>
              <FormField label="No. of Bathrooms">
                <div className="relative">
                  <select
                    name="bathrooms"
                    value={formData.bathrooms}
                    onChange={handleInputChange}
                    className="form-select"
                  >
                    <option value="">Select no. of Bedrooms</option>
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4+">4+</option>
                  </select>
                  <div className="absolute right-4 top-1/2 -translate-y-1/2 pointer-events-none">
                    <ChevronDown />
                  </div>
                </div>
              </FormField>
              <FormField label="No. of Bedrooms">
                <div className="relative">
                  <select
                    name="bedrooms"
                    value={formData.bedrooms}
                    onChange={handleInputChange}
                    className="form-select"
                  >
                    <option value="">Select no. of Bedrooms</option>
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                    <option value="5+">5+</option>
                  </select>
                  <div className="absolute right-4 top-1/2 -translate-y-1/2 pointer-events-none">
                    <ChevronDown />
                  </div>
                </div>
              </FormField>
            </div>

            {/* Third Row: Budget and Contact Method */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-5">
              <FormField label="Budget">
                <div className="relative">
                  <select
                    name="budget"
                    value={formData.budget}
                    onChange={handleInputChange}
                    className="form-select"
                  >
                    <option value="">Select Budget</option>
                    <option value="under-500k">Under $500k</option>
                    <option value="500k-1m">$500k - $1M</option>
                    <option value="1m-2m">$1M - $2M</option>
                    <option value="2m-plus">$2M+</option>
                  </select>
                  <div className="absolute right-4 top-1/2 -translate-y-1/2 pointer-events-none">
                    <ChevronDown />
                  </div>
                </div>
              </FormField>
              <FormField label="Preferred Contact Method">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                  <button
                    type="button"
                    onClick={() =>
                      setFormData((prev) => ({ ...prev, contactMethod: "phone" }))
                    }
                    className={`contact-method-button ${
                      formData.contactMethod === "phone" ? "active" : ""
                    }`}
                  >
                    <PhoneIcon />
                    <span className="flex-1 text-left text-sm">Enter Your Number</span>
                    <div
                      className={`radio-indicator ${
                        formData.contactMethod === "phone" ? "active" : ""
                      }`}
                    />
                  </button>
                  <button
                    type="button"
                    onClick={() =>
                      setFormData((prev) => ({ ...prev, contactMethod: "email" }))
                    }
                    className={`contact-method-button ${
                      formData.contactMethod === "email" ? "active" : ""
                    }`}
                  >
                    <MailIcon />
                    <span className="flex-1 text-left text-sm">Enter Your Email</span>
                    <div
                      className={`radio-indicator ${
                        formData.contactMethod === "email" ? "active" : ""
                      }`}
                    />
                  </button>
                </div>
              </FormField>
            </div>

            {/* Message Field */}
            <FormField label="Message">
              <textarea
                name="message"
                value={formData.message}
                onChange={handleInputChange}
                placeholder="Enter your Message here.."
                rows={5}
                className="form-textarea"
              />
            </FormField>

            {/* Terms and Submit Button */}
            <div className="flex flex-col lg:flex-row lg:items-center gap-4">
              <label className="flex items-start lg:items-center gap-2 flex-1 cursor-pointer">
                <div className="relative flex-shrink-0 mt-0.5 lg:mt-0">
                  <input
                    type="checkbox"
                    name="termsAccepted"
                    checked={formData.termsAccepted}
                    onChange={handleInputChange}
                    className="sr-only"
                  />
                  <div className="w-4 h-4 border border-gray-300 bg-white flex items-center justify-center">
                    {formData.termsAccepted && (
                      <svg
                        className="w-3 h-3 text-primary"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                        <path
                          fillRule="evenodd"
                          d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                          clipRule="evenodd"
                        />
                      </svg>
                    )}
                  </div>
                </div>
                <span className="text-black text-xs md:text-sm font-normal leading-[150%]">
                  I agree with{" "}
                  <span className="underline">Terms of Use</span> and{" "}
                  <span className="underline">Privacy Policy</span>
                </span>
              </label>
              <button
                type="submit"
                className="px-4 py-2.5 bg-card-primary hover:bg-button-primary-hover transition-colors whitespace-nowrap"
              >
                <span className="text-white text-sm font-medium">
                  Send Your Message
                </span>
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}

function FormField({
  label,
  children,
}: {
  label: string;
  children: React.ReactNode;
}) {
  return (
    <div className="flex flex-col gap-2">
      <label className="text-black text-sm md:text-base font-semibold leading-[150%]">
        {label}
      </label>
      {children}
    </div>
  );
}


